import { ObjectField, NoPointers, Float32Field, } from "@opendaw/lib-box";
export class Fading extends ObjectField {
    static create(construct) {
        return new Fading(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get in() {
        return this.getField(1);
    }
    get out() {
        return this.getField(2);
    }
    get inSlope() {
        return this.getField(3);
    }
    get outSlope() {
        return this.getField(4);
    }
    initializeFields() {
        return {
            1: Float32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "in",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "ppqn", 0),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "out",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "ppqn", 0),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "inSlope",
                deprecated: false,
                pointerRules: NoPointers,
            }, "unipolar", "ratio", 0.75),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "outSlope",
                deprecated: false,
                pointerRules: NoPointers,
            }, "unipolar", "ratio", 0.25),
        };
    }
}
